import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spacer, ButtonDS, TextCapitalized } from "@qivia/ui";
import { Page } from "../components/Page";
import { useAppSelector } from "../../redux/hooks";
import { selectUnauthorizedStations } from "../qrCode/menuSlice";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import "../../i18n/i18n";

export const UnauthorizedStationsPage = () => {
  const { t } = useTranslation();
  const unauthorizedStations = useAppSelector(selectUnauthorizedStations);

  if (!unauthorizedStations) {
    return;
  }

  return (
    <Page
      title={t("driverPayment.unauthorizedStations.title")}
      backgroundColor="white"
      bottomButton={
        <StyledBottomButton>
          <ButtonDS
            text={t("stations.button.back")}
            buttonType="primary"
            format="hug"
            onClick={() => window.history.back()}
          />
        </StyledBottomButton>
      }
      withoutOverflowContent
    >
      <StyledContainer>
        <Spacer y={1} />
        <TextCapitalized>
          {t(`driverPayment.unauthorizedStations.body`)}
        </TextCapitalized>
        <Spacer y={1} />
        {unauthorizedStations.map((station) => {
          return (
            <StyledStation key={station}>
              <StyledFlex>
                - <Spacer x={1} />
                <TextCapitalized>
                  {t(`merchantGroups.${station}`)}
                </TextCapitalized>
              </StyledFlex>
              <Spacer y={1} />
            </StyledStation>
          );
        })}
        <Spacer y={1} />
      </StyledContainer>
    </Page>
  );
};

const StyledContainer = styled.div`
  color: ${colors["colors/text/black"]};
  ${typographies["Body/XL"]}
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
const StyledStation = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors["colors/text/black"]};
  ${typographies["Body/M"]}
`;

const StyledBottomButton = styled.div`
  width: 100%;
`;

const StyledFlex = styled.div`
  display: flex;
`;
